const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const Dagger = require('../../../game_items/equipment/weapon/Dagger.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const snake = (level) => {
  const handle = 'snake';
  const types = ['beast', 'poisonous', 'reptile', 'snake'];
  const AI_PRIORITIES = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];
  const bags = [
    {
      items: [{ value: ItemGenerator.getCavernsMobItem(Dagger, level) }],
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'snake_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          poison_weapon: {
            handle: 'poison_weapon',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          preparation: {
            handle: 'preparation',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(4 + bound_level * 0.6 + Math.random() * 3),
      perception: Math.round(8 + bound_level * 0.9 + Math.random() * 3),
      mana: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      toughness: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
      strength: Math.round(6 + bound_level * 0.8 + Math.random() * 3),
      willpower: Math.round(5 + bound_level * 0.6 + Math.random() * 3),
      dexterity: Math.round(11 + bound_level * 1.4 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 1000,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'poison_weapon' },
      ],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = snake;
